import MicIcon from '@mui/icons-material/Mic';
import { useTheme } from '@mui/styles';
import { Song } from 'services/store/songs/types';

type PropsType = {
  song: Song | null;
};

const MicSection = ({ song }: PropsType) => {
  const theme = useTheme();

  if (!song || !('hasVocals' in song) || !song.hasVocals) {
    return null;
  }

  return (
    <MicIcon
      sx={{
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('xl')]: {
          display: 'none',
        },
        color: theme.palette.grey[400],
      }}
    />
  );
};

export default MicSection;
